import { find, invoke, escapeRegExp } from 'lodash';

export const buildUrl = (url: string, videoHost: string) => {
  const OPTIONAL_QUERY_PARAMS_PATTERN = /(?:&?[^=&]*=[^=&]*)*/;
  const YOUTUBE_VIDEO_ID_PATTERN = /&?v=([a-z\-_\d]+)/;

  const YOUTUBE_PATTERNS = [
    () => /https?:\/\/www\.youtube\.com\/embed\/([a-z\-_\d]+)/gi,
    () =>
      new RegExp(
        /https?:\/\/www\.youtube\.com\/watch\?/.source +
          OPTIONAL_QUERY_PARAMS_PATTERN.source +
          YOUTUBE_VIDEO_ID_PATTERN.source,
        'i',
      ),
    () =>
      new RegExp(
        /https?:\/\/m\.youtube\.com\/watch\?/.source +
          OPTIONAL_QUERY_PARAMS_PATTERN.source +
          YOUTUBE_VIDEO_ID_PATTERN.source,
        'i',
      ),
    () => /https?:\/\/youtu\.be\/([a-z\-_\d]+)/gi,
  ];
  const VIMEO_PATTERNS = [
    () => /https?:\/\/vimeo\.com\/(\d+)/gi,
    () => /https:\/\/player\.vimeo\.com\/video\/(\d+)/gi,
  ];
  const MEDIA_MANAGER_PATTERNS = [
    () => new RegExp(`${escapeRegExp(videoHost)}/video/.+/.+/mp4/file.mp4$`, 'i'),
    () => /https?:\/\/video\.wixstatic\.com\/([a-z\-_\d]+)/gi,
  ];

  const _isSupported = (patterns: (() => RegExp)[], url: string) => {
    let result = false;
    patterns
      .map((fn) => fn())
      .forEach((pattern) => {
        result = result || Boolean(pattern.exec(url));
      });
    return result;
  };

  const extractVideoId = (patterns: (() => RegExp)[], url: string) => {
    let result: string | undefined;
    patterns
      .map((fn) => fn())
      .forEach((pattern) => {
        const matches = pattern.exec(url);
        if (matches) {
          result = matches[1];
        }
      });
    return result;
  };

  const PROVIDERS = [
    {
      isSupported: (url: string) => _isSupported(YOUTUBE_PATTERNS, url),
      buildEmbedUrl: (url: string) => {
        const videoId = extractVideoId(YOUTUBE_PATTERNS, url);
        return `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
      },
      buildUrl: (url: string) => {
        const videoId = extractVideoId(YOUTUBE_PATTERNS, url);
        return `https://youtu.be/${videoId}`;
      },
    },
    {
      isSupported: (url: string) => _isSupported(VIMEO_PATTERNS, url),
      buildEmbedUrl: (url: string) => {
        const videoId = extractVideoId(VIMEO_PATTERNS, url);
        return `https://player.vimeo.com/video/${videoId}?api=1`;
      },
      buildUrl: (url: string) => {
        const videoId = extractVideoId(VIMEO_PATTERNS, url);
        return `https://vimeo.com/${videoId}`;
      },
    },
    {
      isSupported: (url: string) => _isSupported(MEDIA_MANAGER_PATTERNS, url),
      buildEmbedUrl: (url: string) => url,
      buildUrl: (url: string) => url,
    },
  ];

  const getProvider = (url: string) => {
    return find(PROVIDERS, (provider) => provider.isSupported(url));
  };

  return invoke(getProvider(url), 'buildUrl', url);
};
